import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ProductsCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-24 bg-[#f5f0e8]" ref={ref}>
      <div className="max-w-4xl mx-auto px-6 md:px-16 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-7">
            <span className="w-10 h-px bg-[#8b6f47]"></span>
            <i className="ri-sparkling-2-line text-[#8b6f47] text-lg"></i>
            <span className="w-10 h-px bg-[#8b6f47]"></span>
          </div>
          <h2
            className="text-[#2d2520] font-bold mb-5 leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            找不到適合的商品？
          </h2>
          <p
            className="text-[#7a6a5a] leading-[1.75] mb-10 max-w-lg mx-auto"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            每個人的能量需求都不同，歡迎透過 LINE 或電子郵件與我們聯繫，我們將為您提供專屬的能量飾品諮詢服務。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://line.me"
              rel="nofollow"
              target="_blank"
              className="inline-flex items-center justify-center gap-2 px-9 py-4 bg-[#8b6f47] text-white rounded-full text-[1rem] font-medium tracking-wide cursor-pointer hover:bg-[#7a5f3a] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              <i className="ri-line-line text-lg"></i>
              LINE 諮詢
            </a>
            <button
              onClick={() => { navigate("/about"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="inline-flex items-center justify-center gap-2 px-9 py-4 border-2 border-[#2d2520] text-[#2d2520] rounded-full text-[1rem] font-medium tracking-wide cursor-pointer hover:bg-[#2d2520] hover:text-white transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              了解品牌故事
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
